import React from 'react'
import Icon from '../misc/Icons'

// Marks a search hit that came from the local engine rather than Algolia.
// Purely a quality-evaluation cue while local content search runs as a shadow,
// so it is hidden in production; the hit markers themselves (__localOrigin /
// __localEngine) are set by the local providers.
function LocalBadge({ hit }) {
  if (process.env.REACT_APP_ENV === 'production') return null
  if (!hit || !hit.__localOrigin) return null
  return <Icon name='local-source-bm25' className='searchResults-localBadge searchResults-localBadge--bm25' />
}

export default LocalBadge
